import { Component, OnInit } from '@angular/core';
import {UserService} from "../../services/user.service";
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-custom-listonosz',
  templateUrl: './custom-listonosz.component.html',
  styleUrls: ['./custom-listonosz.component.scss'],
})
export class CustomListonoszComponent implements OnInit {

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {}
  async selection_clicked(value: boolean) {
    await this.modalCtrl.dismiss(value, 'finished');
  }
}
